import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import { faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import Footer from "../components/footer/Footer";
// import { faSquareCheck, faCheck } from "@fortawesome/free-solid-svg-icons";

const PrivacyPolicy = () => {
  return (
    <div className="bg-black pb-20">
      {/* header */}
      <Navbar />

      <div className="mt-6 px-5 sm:px-10 xl:px-16 2xl:px-32 w-min text-white">
        <Link
          to="/ordermanage"
          className="bg-slate-900 border border-slate-800 rounded-full p-2"
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
            className="w-5 h-5 text-white/800 cursor-pointer pt-0.5"
          />
        </Link>
      </div>

      <div className="cardBorder1 borderFN mx-3 xs:mx-5 sm:mx-10 xl:mx-16 2xl:mx-32 mt-5 font-body ">
        <div id="grad" className="rounded-lg">
          <div className="font-body">
            <div className="bg-gradient-to-r from-[#0c0c0c] via-[#444444] to-[#0c0c0c] rounded-t-xl">
              <h2 className="text-white text-xl text-left px-5 lg:px-10 py-2.5">
                Privacy Policy
              </h2>
            </div>
            <h2 className="font-body text-lg sm:text-xl md:text-2xl lg:text-3xl font-normal text-center text-slate-100 px-5 md:px-20 xl:px-44 py-5 leading-10">
              Tracklimo Chauffeur Privacy Policy (TL)
            </h2>
            <div className="px-5 lg:px-10 text-slate-100">
            <h2 className="font-body text-xl lg:text-2xl font-semibold text-white pb-6">
                I. Scope
              </h2>
              <h2 className="font-body py-1 text-white">
                This Tracklimo Chauffeur App by Drivado and its Privacy Policy
                (TL) will inform you as an applicant to become a Drivado
                chauffeur, as partner of Drivado providing transportation
                services to Drivado&#39;s end customers or as a chauffeur for
                Drivado&#39;s end customers as to which personal data about you
                is processed by Drivado and for what purpose. For the use of
                Drivado&#39;s website and other Drivado services Drivado&#39;s
                general Privacy Policy and Cookie Policy apply:&nbsp;
                <Link
                  to="https://drivado.com/#/privacyPolicy"
                  className="font-body font-semibold hover:text-slate-300"
                >
                  https://drivado.com/#/privacyPolicy
                </Link>
                <br />
                <br />
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                II. Name and Contact Information of the Controller
              </h2>
              <h2 className="font-body py-1">
                The controller for the processing of data within the meaning of
                the General Data Protection Regulation (GDPR) is:
                <br />
                <br />
                Drivado Transfers Pvt. Ltd.,
                <br />
                Unit #506,
                <br />
                Merlin Infinite DN-51,
                <br />
                Street Number 11, DN Block,
                <br />
                Sector V, Bidhannagar, Kolkata,
                <br />
                West Bengal 700091, India
                <br />
                <br />
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                III. Application of partners or chauffeurs
              </h2>
              <h2 className="font-body py-1">
                Personal data provided will be processed as part of your
                application in order to determine your suitability for chauffeur
                services for Drivado&#39;s end customers. This includes
                information about whether a partner or chauffeur is
                appropriately qualified, licensed, experienced, sufficiently
                cleared by criminal background checks (if required or permitted
                by local law), capable of performing the chauffeur services and
                whether he fully complies with any and all guidelines or other
                requirements of Drivado.
                <br />
                <br />
                Your data are necessary for the conclusion of a partner or
                transportation contract, otherwise we cannot process your
                application or offer you requests for transportation services.
                Drivado’s decision on your application is not solely based on
                automated processing.
                <br />
                <br />
                Application data is usually not forwarded to external
                recipients, unless it is a Drivado contractor{" "}
                <span className="text-blue-300">(see Art. 28 GDPR)</span> or
                otherwise legally permitted. If your application is successful,
                your application data will be used for the contractual
                relationship with Drivado and the provision of professional
                chauffeur services for Drivado&#39;s end customers{" "}
                <span className="text-blue-300">(see Section 6 below)</span>.
                Otherwise, your application data will generally be deleted after
                6 months, unless there is an additional need or reason to store
                the data longer.
                <br />
                <br />
                The legal basis for our processing of application data is{" "}
                <span className="text-blue-300">
                  Article 6 Paragraph 1 lit b GDPR
                </span>{" "}
                (contract initiation). If you give us your consent to transmit
                personal data beyond the required extent, the legal basis is{" "}
                <span className="text-blue-300">
                  Art. 6 Paragraph 1 lit. a GDPR (consent)
                </span>
                .
                <br />
                <br />
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                IV. Chauffeur data, rides, contractual relationship
              </h2>
              <h2 className="font-body py-1">
                Drivado processes partner or chauffeur application data and
                partner or chauffeur data arising from the contractional
                relationship or the provision of Drivado chauffeur services
                (hereinafter “chauffeur data”). Chauffeur data will be used for
                Drivado services, i.e. for the fulfilment of the Framework
                Cooperation and Transportation Services Agreement with a
                partner, for transportation requests, transportation contracts
                or for accounting and payment purposes. This can include data
                like: Full name, gender, birth date, age, licenses, place of
                birth, physical address, email, telephone number, social
                security number, tax ID, pay-out preference or bank account,
                user ID, trainings and webinars, location data, ride status,
                tour milestones, vehicle number plate, vehicle details, customer
                orders, customer ratings, photographs, audio files, incident
                information, criminal background checks, compliance with Drivado
                guidelines company data.
                <br />
                <br />
                Drivado provides chauffeur data to third parties, if necessary,
                in particular to end customers of Drivado so that the end
                customer can be transported in accordance with their booking and
                the transport can be processed, accounted and paid for.
                Chauffeur data can in such cases be transmitted in a third-party
                country outside of the European Union or the European Economic
                Area in which the end customer is located or planning to use
                Drivado services. Drivado cannot generally provide further
                information on the data protection level in the third-party
                country. An adequacy decision{" "}
                <span className="text-blue-300">
                  (see Art. 45 Paragraph 3 GDPR)
                </span>{" "}
                or suitable guarantees{" "}
                <span className="text-blue-300">(see Art. 46 GDPR)</span> are
                not required for the transmission since the transmission is
                required for the performance of a contract between the data
                subject and the controller or to carry out pre-contractual
                measures upon request from the data subject{" "}
                <span className="text-blue-300">
                  (Art. 49 Paragraph 1 lit b GDPR)
                </span>{" "}
                or because the transmission is required to enter into or to
                perform a contract concluded in the interest of the data subject
                by the controller with another natural or legal person{" "}
                <span className="text-blue-300">
                  (Art. 49 Paragraph 1 lit c GDPR)
                </span>
                .
                <br />
                <br />
                The legal basis for the processing of chauffeur data is{" "}
                <span className="text-blue-300">
                  Art. 6 Paragraph 1 lit b GDPR
                </span>{" "}
                (contract performance). If the chauffeur provides additional,
                voluntary information, the legal basis is chauffeurs’ consent
                according to{" "}
                <span className="text-blue-300">
                  Art. 6 Paragraph 1 lit a GDPR
                </span>{" "}
                and our legitimate interest according to{" "}
                <span className="text-blue-300">
                  Art. 6 Paragraph 1 lit f GDPR
                </span>
                .
                <br />
                <br />
                In addition, Drivado processes chauffeur data in order to
                analyze, personalize and improve the use of Drivado services
                (e.g. ride reviews, to advertise Drivado services, to detect,
                limit and eliminate technical or process-related disruptions and
                problems, and to prevent illegal use of Drivado services (e.g.
                fraudulent booking, cyberattacks). For such purposes chauffeur
                data usually is not forwarded to recipients, unless it is to the
                chauffeurs’ employer or principal, a Drivado contractor{" "}
                <span className="text-blue-300">(see Art. 28 GDPR)</span> or if
                otherwise legally permitted (e.g. in order to assert or reject
                claims). The legal basis for the processing of chauffeur data
                is, in this respect, is{" "}
                <span className="text-blue-300">
                  Art. 6 Paragraph 1 lit f GDPR
                </span>{" "}
                (Drivado&#39;s legitimate interest).
                <br />
                <br />
              </h2>

              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                V. TracklimoChauffeur App and Drivado Partner Portal
              </h2>
              <h2 className="font-body py-1">
                Drivado operates an App for mobile devices (“Tracklimo”) and an
                online portal for Partners (“Tracklimo”, together “Drivado
                Chauffeur Tools”) for the communication with chauffeurs and the
                processing of end customer’s service requests. Data generated or
                used while utilising the Drivado Chauffeur Tools, i.e. all
                chauffeur tools data (e.g. login, password) or ride related data
                (e.g. date, time, pickup, drop-off, stopover, pax number,
                vehicle category/class, pick-up sign information and logo, end
                customer name, end customer mobile number, flight or train,
                reference number, booking comments, special needs,
                cancellations, changes to bookings, no shows and delays), are
                otherwise processed like chauffeur data for the purposes and as
                described in Section 6 above.
                <br />
                <br />
                Drivado&#39;s decision on an offer by a partner or chauffeur can
                be solely based on automated processing. Such an automatic
                decision is required to conclude the contract (Art. 22 Paragraph
                2 lit a GDPR). The data subject has the option of contacting us
                using the mentioned contact data{" "}
                <span className="text-blue-300">(see section 2)</span> in order
                to have an explanation or an intervention by a person or to
                express their point of view.
                <br />
                <br />
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                VI. GPS tracking, location data
              </h2>
              <h2 className="font-body py-1">
                With chauffeurs&#39; consent, Drivado processes and uses GPS
                tracking or location data (i.e. longitude, latitude, speed,
                accuracy). Chauffeurs must first agree to this on their mobile
                device using the confirmation field or the system settings in
                Android or iOS ("Allow"). Chauffeurs’ position is then
                determined using the GPS data from the Drivado Chauffeur App
                (hereinafter “location data”) as soon as the chauffeur starts a
                journey (i.e. as soon as he presses the button "On the way to
                Pick up Location" in the Drivado Chauffeur App) and ends once
                the chauffeur presses the button "Finish Ride" in the Drivado
                Chauffeur App. In case the "Finish Ride" button is not pressed,
                tracking of location data stops automatically 120 minutes after
                the estimated time of arrival at the drop off point.
                <br />
                <br />
                Purposes of processing are the execution of the contractual
                relationship (planning, disposition, arrangement, execution,
                accounting for and payment of transportation), to monitor the
                performance of the ride, to increase the quality of rides, to
                support Drivado, the chauffeur and the customer in case of
                questions or problems, the design and improvement of Drivado
                services, the detection, limitation and elimination of faults,
                errors or problems of a technical or process-related nature and
                the prevention or detection of illegal use (otherwise{" "}
                <span className="text-blue-300">see Section 6 above</span>).
                <br />
                <br />
                Location data may be passed on to the current end customer of
                the chauffeur in order to facilitate and enhance the meeting
                with the chauffeur or for accounting and payment purposes.
                Otherwise, location data will not be transmitted to third
                parties, unless it is a Drivado contractor{" "}
                <span className="text-blue-300">(see Art. 28 GDPR)</span> or
                otherwise legally permitted.
                <br />
                <br />
                Location data is processed safely and stored on encrypted media.
                Location data is not permanently linked to the chauffeurs&#39;
                profile but stored separately. It can only be accessed according
                to a separate authorization concept, which allows only a limited
                group of people access for a limited time. Evaluations are
                otherwise carried out pseudo- or anonymised. Profiling{" "}
                <span className="text-blue-300">
                  (Art. 4 Paragraph 4 GDPR)
                </span>{" "}
                using location data does not take place. Location data is not
                stored for more than 2 years and then deleted or anonymised.
                <br />
                <br />
                The legal bases of the processing of location data by Drivado
                are{" "}
                <span className="text-blue-300">
                  Art. 6 Paragraph 1 lit a GDPR (consent)
                </span>{" "}
                and{" "}
                <span className="text-blue-300">
                  Art. 6 Paragraph 1 lit b GDPR
                </span>{" "}
                (contract performance and contract initiation). The described
                tracking of location data is necessary, so the chauffeur can use
                a navigation app at the same time whilst using the GPS tracking
                on the Drivado Chauffeur App. Rides can only be performed when
                GPS tracking is active and switched on for the Drivado Chauffeur
                App. The chauffeur can withdraw his consent to GPS tracking at
                any time by changing the device settings for the Drivado
                Chauffeur App. Such withdrawal of consent will not affect the
                processing of chauffeur’s location data tracked before driver’s
                withdrawal. The chauffeur can also withdraw his consent to
                further use of his location data at any time by sending us a
                message to that effect (communication channels{" "}
                <span className="text-blue-300">
                  see Sections 2 and 3 above
                </span>
                ). Such withdrawal of consent will not affect the processing of
                chauffeur&#39;s location data before driver&#39;s withdrawal.
                <br />
                <br />
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                VII. Credit Card Data
              </h2>
              <h2 className="font-body py-1">
                Tracklimo has no usage for credit card as no payment iss
                processed in the App or website.
                <br />
                <br />
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                VIII. Communication with Drivado
              </h2>
              <h2 className="font-body py-1">
                If you contact Drivado (e.g. by phone call, video conference,
                contact form, chat, messenger, text message, e-mail or via the
                Drivado Chauffeur App), the data provided by you will be
                processed to handle your matter and to answer your question. The
                legal bases are{" "}
                <span className="text-blue-300">
                  Art. 6 Paragraph 1 lit a GDPR (consent)
                </span>{" "}
                and{" "}
                <span className="text-blue-300">
                  Art. 6 Paragraph 1 lit b GDPR
                </span>{" "}
                (contract performance and contract initiation). Drivado will
                also use external services and tools to communicate with
                chauffeurs.
                <br />
                <br />
                Drivado will process personal data from the communication, as
                far as possible in a pseudonymized or anonymized form, to
                analyse usage, design and improve Drivado services, to detect
                and remedy interruptions and technical or process-related
                problems and to prevent illegal usage of Drivado services (e.g.
                fraudulent booking, cyberattacks). The legal basis for the
                processing is{" "}
                <span className="text-blue-300">
                  Art. 6 Paragraph 1 lit f GDPR
                </span>{" "}
                (Drivado&#39;s legitimate interest).
                <br />
                <br />
              </h2>

              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                IX. Rights of data subjects
              </h2>
              <h2 className="font-body py-1">
                If your personal data is processed by Drivado, you are the data
                subject{" "}
                <span className="text-blue-300">(Art. 4 No. 1 GDPR)</span>
                . As the data subject, you have the following rights in relation
                to the personal data affecting you:
                <br />
                <br />
              </h2>
              <div className="text-white sm:ml-5">
                <h2 className="font-semibold text-xl py-5">
                  1. Right to information (Art. 15 GDPR)
                </h2>
                <h2 className="py-1">
                  The data subject has the right to obtain a confirmation from
                  the controller as to whether personal data is processed; if
                  this is the case, they have a right of information about this
                  personal data and further information on the data processing.
                </h2>

                <h2 className="font-semibold text-xl py-5">
                  2. Right to rectification (Art. 16 GDPR)
                </h2>
                <h2 className="py-1">
                  The data subject has the right to obtain from the controller
                  without undue delay the rectification or completion of
                  inaccurate personal data.
                </h2>

                <h2 className="font-semibold text-xl py-5">
                  3. Right to erasure (Art. 17 GDPR)
                </h2>
                <h2 className="py-1">
                  The data subject has the right to demand from the controller
                  the erasure of personal data without undue delay and the
                  controller is obliged to erase personal data without undue
                  delay, provided the data is no longer required, the data
                  subject revokes their consent or lodges an objection to the
                  processing, the personal data was processed unlawfully or
                  there is otherwise a ground for erasure within the meaning of{" "}
                  <span className="text-blue-300">Art. 17 GDPR</span> and the
                  controller does not have the right to object to erasure.
                </h2>

                <h2 className="font-semibold text-xl py-5">
                  4. Right to the restriction of data processing (Art. 18 GDPR)
                </h2>
                <h2 className="py-1">
                  The data subject has the right to demand from the controller
                  the restriction of processing when one of the conditions
                  mentioned in Art. 18 GDPR applies, namely the accuracy of the
                  personal data is contested by the data subject or the
                  processing is unlawful, and the data subject opposes the
                  erasure of the personal data.
                </h2>

                <h2 className="font-semibold text-xl py-5">
                  5. Right to objection (Art. 21 GDPR)
                </h2>
                <h2 className="py-1">
                  Insofar as the data processing is based on a legitimate
                  interest from our side{" "}
                  <span className="text-blue-300">
                    (Art. 6 Paragraph 1 lit. f GDPR)
                  </span>{" "}
                  or is direct advertising, the data subject has at any time the
                  right to lodge an objection to the processing of personal data
                  affecting them for the reasons mentioned in{" "}
                  <span className="text-blue-300">Art. 21 GDPR</span>. The
                  controller will then no longer process the personal data,
                  unless they can demonstrate compelling legitimate grounds for
                  the processing which override the interests, rights and
                  freedoms of the data subject or the processing serves for the
                  establishment, exercise or defense of legal claims.
                </h2>

                <h2 className="font-semibold text-xl py-5">
                  6. Right to data portability (Art. 20 GDPR)
                </h2>
                <h2 className="py-1">
                  The data subject has the right within the meaning of{" "}
                  <span className="text-blue-300">Art. 20 GDPR</span> to receive
                  the personal data, which they have provided to a controller,
                  in a structured, commonly used and machine-readable format and
                  have the right to transmit this data to another controller
                  without hindrance from the controller to which the personal
                  data has been provided.
                </h2>

                <h2 className="font-semibold text-xl py-5">
                  7. Right to lodge a complaint (Art. 77 GDPR)
                </h2>
                <h2 className="py-1">
                  Without prejudice to any other administrative or judicial
                  remedy, every data subject has the right to lodge a complaint
                  with a supervisory authority according to{" "}
                  <span className="text-blue-300">Art. 77 GDPR</span>.
                </h2>
                <br />
              </div>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                X. Data Erasure and Storage Period
              </h2>
              <h2 className="font-body py-1">
                We will delete your personal data as soon as the legal basis for
                its processing no longer applies. In some cases, however, other
                legal bases can also apply, for example if processing is
                necessary for compliance with a legal obligation of Drivado
                (e.g. in accordance with commercial or tax law).
                <br />
                <br />
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                XI. Amendment or Update of this Chauffeur Privacy Policy
              </h2>
              <h2 className="font-body py-1">
                Drivado may update and amend this Driver Privacy Policy at any
                time. Chauffeurs will be informed and may be requested to
                provide consent again.
                <br />
                <br />
                Drivado Transfers Pvt. Ltd.,
                <br />
                Unit #506,
                <br />
                Merlin Infinite DN-51,
                <br />
                Street Number 11, DN Block,
                <br />
                Sector V, Bidhannagar, Kolkata,
                <br />
                West Bengal 700091, India
                <br />
                <br />
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                Contact Us
              </h2>
              <h2 className="font-body py-1">
                Drivado Transfers Pvt. Ltd.,
                <br />
                Unit #506,
                <br />
                Merlin Infinite DN-51,
                <br />
                Street Number 11, DN Block,
                <br />
                Sector V, Bidhannagar, Kolkata,
                <br />
                West Bengal 700091, India
                <br />
                Support@drivado.com
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                Privacy Policy
              </h2>
              <h2 className="font-body py-1 pb-10">
                We use cookies. By continuing to use our online service you
                consent to the use of cookies in accordance with our Cookie
                Policy.
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="px-5 sm:px-10 xl:px-16 2xl:px-32"><Footer /></div>
    </div>
  );
};

export default PrivacyPolicy;
